// extracted by mini-css-extract-plugin
export var container = "index-module--container--CtfrA";
export var btn = "index-module--btn--2tSUv";
export var title = "index-module--title--1cAAU";
export var tagListing = "index-module--tagListing--2sytg";